<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="ib-layout__header ib-layout__header--pre-title-large u-text-right">
                <a class="ib-link ib-link--icon hidden-md hidden-sm hidden-xs" (click)="printSummary()"
                    title="{{'CONFIRM_PRINT_PAYMENT'|translate}}">
                    <span class="ib-link__icon icon-imprimir"></span>
                    <span class="ib-link__text">{{'CONFIRM_PRINT_CONFIRM'|translate}}</span>
                </a>
                <h1 class="ib-heading ib-heading--type-18 ib-heading--block ib-heading--to-center">
                    <span
                        class="ib-heading__icon ib-heading__icon--default ib-heading__icon--mobile-block icon-confirmacion hidden-xs hidden-sm"></span>
                    <span class="ib-heading__text">{{'CONFIRM_BUY_OK_TXT'|translate}}</span>
                </h1>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-lg-8">
            <div class="ib-layout__section ib-layout__section--large-responsive">
                <div class="ib-box ib-box--empty ib-box--bordered ib-box--gift-card">
                    <div class="ib-box__wrapper ib-box__wrapper--xsmall">
                        <div class="ib-layout__line-spacing" *ngIf="theme">
                            <div class="ib-gift-card ib-gift-card--small">
                                <figure class="ib-gift-card__logo">
                                    <img [src]="viewModel?.logo" [alt]="viewModel?.translates?.altLogo" />
                                </figure>
                                <figure class="ib-gift-card__figure">
                                    <img [src]="viewModel?.backGroundImage" [alt]="viewModel?.translates?.altFigure" />
                                </figure>
                                <figure class="ib-gift-card__icon"
                                        [ngClass]="viewModel?.iconClass">
                                    <img [src]="viewModel?.icon" [alt]="viewModel?.translates?.altTheme" />
                                </figure>
                                 <div class="ib-gift-card__description ib-gift-card__description--long-coins">                                  
                                    <span class="ib-gift-card__title">{{'GIFT_CARD_CONFIGURATION_GIFT_CARD_TEXT'|translate}}</span>
                                    <span class="ib-gift-card__price ib-gift-card__price--long-coins"> {{ summaryComponent.props.totalGiftcardAmount }}</span>
                                    <span class="ib-gift-card__txt"> {{'EXPIRY_DATE_FIELD_TITLE' | translate}}: {{ summaryComponent.props.expiryDateTo }}</span>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div class="ib-box__wrapper ib-box__wrapper--medium">
                        <div
                            class="ib-layout__line-spacing ib-layout__line-spacing--text-center ib-layout__line-spacing--xmedium-responsive ">
                            <p class="ib-text ib-text--to-center ib-text--color-unfocused ib-text--lh-normal-responsive">
                                {{this.confimationEmailLiteral}}.
                            </p>
                        </div>

                        <div *ngIf="typeOfCard.isGiftCardColavorative" class="ib-layout__line-spacing ib-layout__line-spacing--text-center">
                            
                            <div *ngIf="!typeOfCard.colavorativeType.isContribution" class="ib-box ib-box--medium-responsive">
                                <span *ngIf="typesOfShipping.forAnotherByEmail || typesOfShipping.forAnotherByEmailAndHand"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_DELIVERY'|translate).replace('{{email}}', recipientEmail).replace('{{date}}', dateTimeLocalUTC) }}
                                </span>
                                <div *ngIf="typesOfShipping.forAnotherByEmailAndHand">
                                    <br/>
                                </div>
                                <span *ngIf="typesOfShipping.forAnotherByHand || typesOfShipping.forAnotherByEmailAndHand"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_DELIVERY_HAND'|translate).replace('{{email}}', senderEmail).replace('{{date}}', dateTimeLocalUTC) }}
                                </span>
                            </div>

                            <div *ngIf="typeOfCard.colavorativeType.isContribution" class="ib-box ib-box--medium-responsive">
                                <span *ngIf="typesOfShipping.forAnotherByEmail ||typesOfShipping.forAnotherByEmailAndHand"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_DELIVERY_CONTRIBUTION'|translate).replace('{{email}}', recipientEmail).replace('{{date}}', dateTimeLocalUTC) }}
                                </span>
                                <div *ngIf="typesOfShipping.forAnotherByEmailAndHand">
                                    <br/>
                                </div>
                                <span *ngIf="typesOfShipping.forAnotherByHand ||typesOfShipping.forAnotherByEmailAndHand"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_DELIVERY_CONTRIBUTION_HAND'|translate).replace('{{email}}', senderEmail).replace('{{date}}') }}
                                </span>
                            </div>
                        </div>

                        
                        
                        <div *ngIf="typeOfCard.isGiftCard" class="ib-layout__line-spacing ib-layout__line-spacing--text-center">
                            <div class="ib-box ib-box--medium-responsive">
                                <div>
                                    <span *ngIf="typesOfShipping.forOneSelf"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_COMFIRMATION_RECEIVER_GIFTCARD_TEXT'|translate).replace('{{email}}', senderEmail) }}
                                    </span>
                                    <span *ngIf="typesOfShipping.forAnotherByEmail"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_COMFIRMATION_OTHER_BY_EMAIL'|translate).replace('{{receiverEmail}}', recipientEmail ) }}
                                    </span>
                                    <span *ngIf="typesOfShipping.forAnotherByHand"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_COMFIRMATION_OTHER_BY_HAND'|translate).replace('{{email}}', senderEmail ) }}
                                    </span>
                                    <span *ngIf="typesOfShipping.forAnotherByEmailAndHand"
                                        class="ib-text ib-text--inline ib-text--bold ib-text--color-unfocused ib-text--lh-normal-mobile">
                                        {{ ('GIFT_CARD_COMFIRMATION_OTHER_BY_HAND_AND_EMAIL'|translate).replace('{{email}}', senderEmail).replace('{{receiverEmail}}', recipientEmail) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="ib-layout__line-spacing ib-layout__line-spacing--text-center">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-lg-4 ib-layout__section--medium hidden-md hidden-sm hidden-xs">
            <ng-react [component]="summaryComponent.component" [props]="summaryComponent.props"></ng-react>
        </div>
    </div>
    <equal-height id="pmtBoxConfirmationInfo"  class="ib-box-confirmation-info" data-reload="true">
        <div class="row ib-layout__section">
            <div class="col-sm-12 col-md-4">
                <div class="ib-box ib-box--small ib-box--empty ib-box--bordered u-height-auto-sm" data-equal="box-info">
                    <div class="ib-info-icon ib-info-icon--small">
                        <div class="ib-info-icon__wrapper">
                            <span class="ib-info-icon__icon icon-logo_aplic_peque"></span>
                            <div class="ib-info-icon__info">
                                <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
                                    <span
                                        class="ib-heading ib-heading--type-5">{{'CONFIRM_IBERIA_PLUS'|translate}}</span>
                                </div>
                                <span class="ib-text">{{'CONFIRM_IBERIA_PLUS_EXPERIENCE'|translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="ib-box ib-box--small ib-box--empty ib-box--bordered u-height-auto-sm" data-equal="box-info">
                    <div class="ib-info-icon ib-info-icon--small">
                        <div class="ib-info-icon__wrapper">
                            <span class="ib-info-icon__icon icon-editar_perfil"></span>
                            <div class="ib-info-icon__info">
                                <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
                                    <span
                                        class="ib-heading ib-heading--type-5">{{'CONFIRM_HELP_CENTER'|translate}}</span>
                                </div>
                                <span class="ib-text">{{'CONFIRM_HELP_INFO'|translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="ib-box ib-box--small ib-box--empty ib-box--bordered u-height-auto-sm" data-equal="box-info">
                    <div class="ib-info-icon ib-info-icon--small">
                        <div class="ib-info-icon__wrapper">
                            <span class="ib-info-icon__icon icon-mensajes"></span>
                            <div class="ib-info-icon__info">
                                <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
                                    <span
                                        class="ib-heading ib-heading--type-5">{{'CONFIRM_CUSTOMER_SUPPORT'|translate}}</span>
                                </div>
                                <span class="ib-heading" *ngIf="rootScope.phonesList['RESERVAS']"
                                    [class]="{'ib-heading--type-2': (rootScope.phonesList['RESERVAS']?.prefixAlt + ' ' + rootScope.phonesList['RESERVAS']?.telephoneAlt).length < 10,'ib-heading--type-5':(rootScope.phonesList['RESERVAS']?.prefixAlt + ' ' + rootScope.phonesList['RESERVAS']?.telephoneAlt).length >= 10}">{{rootScope.phonesList['RESERVAS']?.prefixAlt
                                    + ' ' + rootScope.phonesList['RESERVAS']?.telephoneAlt}}</span>
                                <span class="ib-text">{{'CONFIRM_CONSULT'|translate}}
                                    <a id="pmt-confirmation-twitter-link" class="ib-link" [href]="twitterLink" target="_blank"
                                        rel="noopener noreferrer"
                                        title="{{'CONFIRM_TWITTER_TITLE'|translate}}">{{'CONFIRM_TWITTER_TITLE'|translate}}</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </equal-height>
    <div id="pmt-iberia-pay-logs" class="sr-only" *ngIf="ibPayTrace">{{ibPayTrace | json }}</div>
</div>



